import { useLocation } from 'react-router-dom';

import { BuyApartmentFlowPaths } from 'routes';

export type AppMode = 'buy' | 'sell' | "";

const useAppMode = (): AppMode => {
  const location = useLocation();
  return location.pathname.startsWith(BuyApartmentFlowPaths.main) ? 'buy' : 'sell';
};

export default useAppMode;
